/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetContractsQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.ContractSearch>;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type GetContractsQuery = {
  __typename?: 'Query',
  contracts: {
    __typename?: 'ContractPage',
    totalElements: number,
    content?: Array<{
      __typename?: 'Contract',
      id: number,
      charterType: Types.CharterType,
      charterSubtype: Types.CharterSubtype,
      contractNumber?: string | null,
      versionNumber?: string | null,
      description?: string | null,
      validFrom?: number | null,
      validUntil?: number | null,
      isEditable: boolean,
      memo?: string | null,
      expired?: boolean | null,
      createdOn?: number | null,
      updatedOn?: number | null,
      isParentContract?: boolean | null,
      statusUpdatedOn?: number | null,
      status: {
        __typename?: 'ContractStatusType',
        name: Types.ContractStatus,
        color: string,
        languageKeyPrefix: string
      },
      labels?: Array<{
        __typename?: 'Label',
        id: number,
        type: Types.LabelType,
        text: string,
        color: string
      }> | null,
      comments: Array<{
        __typename?: 'Comment',
        id: number,
        comment: string,
        created: number,
        createdBy: {
          __typename?: 'AccountDetails',
          id: number,
          username?: string | null,
          displayName?: string | null
        },
        label?: {
          __typename?: 'Label',
          id: number,
          type: Types.LabelType,
          text: string,
          color: string
        } | null
      }>,
      creditor?: {
        __typename?: 'Relation',
        id: number,
        name: string,
        applicationRelation?: boolean | null
      } | null,
      debtor?: {
        __typename?: 'Relation',
        id: number,
        name: string,
        applicationRelation?: boolean | null
      } | null,
      broker?: {
        __typename?: 'Relation',
        id: number,
        name: string,
        applicationRelation?: boolean | null
      } | null,
      charters?: Array<{
        __typename?: 'PurchaseCharter',
        id: number
      } | {
        __typename?: 'SalesCharter',
        id: number
      }> | null
    }> | null
  }
};

export type NextContractStatusesQueryVariables = Types.Exact<{
  currentStatus?: Types.InputMaybe<Types.ContractStatus>;
}>;


export type NextContractStatusesQuery = {
  __typename?: 'Query',
  nextContractStatuses: Array<{
    __typename?: 'ContractStatusType',
    name: Types.ContractStatus,
    color: string,
    languageKeyPrefix: string
  }>
};

export type GetContractsShortQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.ContractSearch>;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type GetContractsShortQuery = {
  __typename?: 'Query',
  contracts: {
    __typename?: 'ContractPage',
    totalElements: number,
    content?: Array<{
      __typename?: 'Contract',
      id: number,
      contractNumber?: string | null,
      description?: string | null,
      validFrom?: number | null,
      validUntil?: number | null,
      charterType: Types.CharterType,
      charterSubtype: Types.CharterSubtype,
      isParentContract?: boolean | null,
      termsAndConditions?: {
        __typename?: 'TermsAndConditions',
        id: number,
        description?: string | null
      } | null,
      charters?: Array<{
        __typename?: 'PurchaseCharter',
        id: number
      } | {
        __typename?: 'SalesCharter',
        id: number
      }> | null,
      broker?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null
    }> | null
  }
};


export const GetContractsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetContracts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSearch"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterType"}},{"kind":"Field","name":{"kind":"Name","value":"charterSubtype"}},{"kind":"Field","name":{"kind":"Name","value":"contractNumber"}},{"kind":"Field","name":{"kind":"Name","value":"versionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"memo"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"updatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"comment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"applicationRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"applicationRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"applicationRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"charters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isParentContract"}},{"kind":"Field","name":{"kind":"Name","value":"statusUpdatedOn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalElements"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"comment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Comment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]} as unknown as DocumentNode<GetContractsQuery, GetContractsQueryVariables>;
export const NextContractStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"nextContractStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextContractStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"currentStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}}]}}]} as unknown as DocumentNode<NextContractStatusesQuery, NextContractStatusesQueryVariables>;
export const GetContractsShortDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getContractsShort"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSearch"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"validFrom"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"charterType"}},{"kind":"Field","name":{"kind":"Name","value":"charterSubtype"}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"charters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isParentContract"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalElements"}}]}}]}}]} as unknown as DocumentNode<GetContractsShortQuery, GetContractsShortQueryVariables>;